export default __webpack_public_path__ + "static/media/no-races-mascot.98330dcc.png";